<template>
  <div>
    <div class="modal fade " tabindex="-1" role="dialog" id="modalAddFile">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">×</span></button>
            <h4 class="modal-title"> Ajouter un fichier</h4>
          </div>
          <div class="modal-body">
            <UploadFiles
              :urlPost="urlUploadFile"
              @filesUploaded="allFilesUploaded()"
              morph="member"
              :id_morph="getMember.id"
            ></UploadFiles>
          </div>
          <div class="modal-footer">
            <button type="button"
                    class="btn btn-default pull-right" data-dismiss="modal">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-alert v-if="getMember.isLicencie" variant="success" show>Ce membre est en ordre de licence jusqu'en
      {{ getMember.licence_active[0].date_fin }}
    </b-alert>
    <b-alert v-if="!getMember.isLicencie" variant="warning" show>Ce membre n'est pas en ordre de licence</b-alert>

    <form role="form">
      <div class="row">
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données administratives</h3>
              <button type="button"
                      :class="{'disabled':getMember.licences.length>0}"
                      class="btn btn-xs btn-danger btn-flat margin pull-right"
                      style="margin-top: 0;margin-bottom: 0;"
                      @click="supprimerMembre()"
              >
                Supprimer le membre
              </button>
            </div>
            <div class="box-body">
              <label for="">Sexe</label>
              <div class="form-group">
                <label class="radio-inline">
                  <input type="radio" name="membre[sexe]" id="radioMasculin"
                         value="1"
                         v-model="getMember.sexe">
                  Masculin
                </label>
                <label class="radio-inline">
                  <input type="radio" name="membre[sexe]" id="radioFeminin"
                         value="0"
                         v-model="getMember.sexe"
                  >
                  Féminin
                </label>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('membre[nom]') }">
                <label for="nom">Nom</label>
                <input type="text" class="form-control" id="nom" name="membre[nom]"
                       v-validate="'required'"
                       placeholder="Nom du membre" v-model="getMember.nom">
                <span v-show="errors.has('membre[nom]')" class="help-block">Le nom est obligatoire</span>
              </div>
              <div class="form-group" :class="{'has-error': errors.has('membre[prenom]') }">
                <label for="prenom">Prénom</label>
                <input type="text" class="form-control" id="prenom" name="membre[prenom]"
                       v-validate="'required'"
                       placeholder="Prénom du membre" v-model="getMember.prenom">
                <span v-show="errors.has('membre[prenom]')" class="help-block">Le prénom est obligatoire</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('membre[date_naissance]') }">
                <label>Date de naissance ({{ getMember.age }} ans)</label>
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                  </div>
                  <masked-input type="text"
                                id="date_naissance"
                                v-model="getMember.date_naissance"
                                v-validate="'required|date_format:DD/MM/YYYY'"
                                :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                :guide="true"
                                :keepCharPositions="true"
                                :showMask="true"
                                name="membre[date_naissance]"
                                class="form-control pull-right datepicker">
                  </masked-input>
                </div>
                <span v-show="errors.has('membre[date_naissance]')"
                      class="help-block">Date incorrecte</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('membre[adresse]') }">
                <label for="adresse">Adresse</label>
                <textarea class="form-control"
                          rows="3"
                          name="membre[adresse]"
                          v-model="getMember.adresse"
                          v-validate="'required|max:255'"
                          placeholder="Adresse du membre...">

                                </textarea>
                <span v-show="errors.has('membre[adresse]')" class="help-block">L'adresse doit comporter moins de 255 caractères</span>
              </div>

              <cp-and-ville
                :cpProp="this.getMember.cp"
                :villeProp="this.getMember.ville"
                placeholder_cp="Code postal du membre"
                placeholder_ville="Ville du membre"
                @villeChanged="setVilleMember"
                @cpChanged="setcpMember"
              >
              </cp-and-ville>

              <div class="form-group">
                <label for="ville">Nationalite</label>
                <select class="form-control" name="membre[nationalite]" v-model="getMember.nationalite">
                  <option value="ZZ">Nationalité
                    indéterminée
                  </option>
                  <optgroup label="Habituels">
                    <option
                      v-for="pays in getPays.habituels"
                      :value="pays.id"
                    >{{ pays.name }}
                    </option>

                  </optgroup>
                  <optgroup label="Autres">
                    <option
                      v-for="pays in getPays.all"
                      :value="pays.id"
                    > {{ pays.name }}
                    </option>
                  </optgroup>
                </select>
                <!--<span class="help-block">Help block with error</span>-->
              </div>

              <!--<div class="form-group">-->
              <!--<label for="ville">Profession</label>-->
              <!--<select class="form-control" name="membre[profession]">-->
              <!--<option-->
              <!--v-for="profession in getProfessions"-->
              <!--v-model="getMember.profession">{{ profession.nom }}-->
              <!--</option>-->
              <!--</select>-->
              <!--<span class="help-block">Help block with error</span>-->
              <!--</div>-->
            </div>
          </div>

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données de contact</h3>
            </div>
            <div class="box-body">
              <div class="form-group" :class="{'has-error': errors.has('membre[mail]') }">
                <label for="mail">E-mail</label>
                <input type="mail" class="form-control" id="email" name="membre[mail]"
                       v-validate="'email'"
                       placeholder="Email du membre"
                       v-model="getMember.mail"
                >
                <span v-show="errors.has('membre[mail]')"
                      class="help-block">Adresse mail incorrecte</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('membre[telephone]') }">
                <label for="telephone">Téléphone</label>
                <input type="text" class="form-control" id="telephone" name="membre[telephone]"
                       placeholder="Téléphone du membre"
                       v-model="getMember.telephone"
                >
                <span v-show="errors.has('membre[telephone]')" class="help-block">Numéro de téléphone incorrect</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('membre[gsm]') }">
                <label for="gsm">GSM</label>
                <input type="text" class="form-control" id="gsm" name="membre[gsm]"
                       placeholder="GSM du membre"
                       v-model="getMember.gsm"
                >
                <span v-show="errors.has('membre[gsm]')"
                      class="help-block">Numéro de GSM incorrect</span>
              </div>

              <label for="">Affichage public ?</label>
              <div class="form-group">
                <label class="radio-inline">
                  <input type="radio" name="membre[affichage_num]" id="radioaucun"
                         value="0"
                         v-model="getMember.affichage_num">
                  Aucun
                </label>
                <label class="radio-inline">
                  <input type="radio" name="membre[affichage_num]" id="radiotel"
                         value="tel"
                         v-model="getMember.affichage_num"
                  >
                  Téléphone
                </label>
                <label class="radio-inline">
                  <input type="radio" name="membre[affichage_num]" id="radiogsm"
                         value="gsm"
                         v-model="getMember.affichage_num"
                  >
                  GSM
                </label>
              </div>
              <div class="form-group" :class="{'has-error': errors.has('membre[comment]') }">
                <label for="adresse">Commentaires</label>
                <textarea class="form-control"
                          rows="3"
                          name="membre[comment]"
                          v-model="getMember.comment"
                          placeholder="Commentaires éventuels...">
                 </textarea>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données sportives</h3>
            </div>
            <div class="box-body">
              <div class="form-group">
                <label for="num_kukkiwon">Numéro Kukkiwon</label>
                <input type="text" class="form-control" id="num_kukkiwon" name="membre[num_kukkiwon]"
                       placeholder="Numéro kukkiwon du membre"
                       v-model="getMember.num_kukkiwon"
                >

                <span class="help-block">Aller sur <a
                  href="http://www.kukkiwon.or.kr/front/eng/main.action">Kukkiwon.or.kr</a></span>
              </div>
              <div class="form-group">
                <label for="num_kukkiwon">Numéro licence GAL</label>
                <input type="text" class="form-control" id="num_gal" name="membre[num_gal]"
                       placeholder="Numéro de la licence GAL du membre"
                       v-model="getMember.num_gal"
                >
              </div>
              <div class="form-group">
                <label for="casierjudiciaire">Date du dernier casier judiciaire</label>
                <masked-input
                  class="form-control "
                  id="casierjudiciaire"
                  v-model="getMember.date_casier_judiciaire"
                  type="text"
                  name="membre[date_casier_judiciaire]"
                  autocomplete="off"
                  :mask="[/[0-3]/,/[0-9]/, '/',/[0-1]/, /[0-9]/,'/',/[1-2]/,/[0-9]/,/[0-9]/, /[0-9]/]"
                  :guide="true"
                  :keepCharPositions="true"
                  :showMask="true">
                </masked-input>
              </div>

              <div class="form-group">
                <label for="statut_sportif">Statut sportif</label>
                <select class="form-control"
                        name="membre[id_statut_sportif]"
                        id="statut_sportif"
                        v-model="getMember.id_statut_sportif">
                  <!--<option value="26">Aucun</option>-->
                  <option
                    v-for="statut in getStatutsSportifs"
                    :value="statut.id"
                  >
                    {{ statut.grade }}
                  </option>
                </select>

              </div>


              <div class="form-group">
                <label for="num_kukkiwon">Compétition</label>
                <div class="checkbox">
                  <label for="discipline">
                    <input id="discipline" name="membre[discipline]" type="checkbox"
                           v-model="getMember.discipline">Problème disciplinaire en cours
                  </label>
                </div>
                <div class="checkbox">
                  <label for="show_in_ranking">
                    <input id="show_in_ranking" type="checkbox" name="membre[show_in_ranking]"
                           v-model="getMember.show_in_ranking">Afficher ce membre au ranking
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="box box-primary">
            <div class="overlay"
                 v-if="isInputLoading('numlicenceABFT')"
            >
              <i class="fa fa-refresh fa-spin"></i>
            </div>

            <div class="box-header with-border">
              <h3 class="box-title">Informations de licence</h3>
            </div>
            <div class="box-body">
              <div class="form-group"
                   :class="{'has-error': numLicenceExist!=null, 'has-success': numLibre==true && numLicenceExist==null }">
                <label for="num_kukkiwon">Numéro de licence</label>
                <div class="input-group">

                  <input type="text" class="form-control" id="num_kukkiwon"
                         name="membre[numlicenceABFT]"
                         @keyup="checkIfNumeroLicenceExist()"
                         placeholder="Numéro de licence du membre"
                         v-model="getMember.numlicenceABFT"
                         :disabled="isInputLoading('numlicenceABFT')"
                  >

                  <div class="input-group-btn">
                    <button type="button" class="btn btn-primary btn-flat"
                            @click="getNewNumeroLicence() ">
                      Obtenir un numéro de licence libre
                    </button>
                  </div>
                </div>
                <span v-if="numLicenceExist!=null"
                      class="help-block">Ce numéro est déjà pris par {{ numLicenceExist.fullName }}</span>
                <span v-if="numLibre==true && numLicenceExist==null"
                      class="help-block">Ce numéro est libre</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('membre[date_entree]') }">
                <label>Date d'entrée à l'ABFT</label>
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                  </div>
                  <masked-input type="text"
                                v-model="getMember.date_entree"
                                name="membre[date_entree]"
                                v-validate="'required|date_format:DD/MM/YYYY|after:membre[date_naissance],true'"
                                :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                :guide="true"
                                :keepCharPositions="true"
                                :showMask="true"
                                data-vv-delay="1000"
                                class="form-control pull-right datepicker"
                                id="date_entree">

                  </masked-input>
                </div>
                <span v-show="errors.has('membre[date_entree]')"
                      class="help-block">Date incorrecte ou antérieure à la date de naissance</span>
              </div>

            </div>
          </div>


          <div class="box box-primary">
            <div class="overlay" v-if="loadingSecretariatBox">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header with-border">
              <h3 class="box-title">Secrétariat</h3>
            </div>
            <div class="box-body">
              <div class="form-group clearfix">
                <label>Secrétariat</label>
                <p>
                  <!--<button type="button" class="btn btn-primary btn-flat col-xs-4 margin">Ajouter un-->
                  <!--suivi-->
                  <!--</button>-->
                  <button type="button"
                          @click.prevent="showModal('#modalAddFile')"
                          class="btn btn-primary btn-flat col-xs-4 margin">Ajouter un
                    fichier
                  </button>
                </p>
              </div>

              <div class="form-group clearfix">
                <label>Demande de licence</label>
                <p>
                  <button
                    @click="printDemandeLicence(moment().year())"
                    type="button" class="btn btn-primary btn-flat col-xs-4 margin">Imprimer la
                    demande de licence
                  </button>
                </p>
              </div>

              <!--              <div class="form-group clearfix">-->
              <!--                <p>-->
              <!--                  <button-->
              <!--                    @click="printDemandeLicence(moment().year()+1)"-->
              <!--                    type="button" class="btn btn-primary btn-sm btn-flat col-xs-4 margin">Imprimer la-->
              <!--                    demande de licence {{moment().year()+1}}-->
              <!--                  </button>-->

              <!--                  <button-->
              <!--                    @click="printDemandeLicence(moment().year()-1)"-->
              <!--                    type="button" class="btn btn-primary btn-sm btn-flat col-xs-4 margin">Imprimer la-->
              <!--                    demande de licence {{moment().year()-1}}-->
              <!--                  </button>-->
              <!--                </p>-->
              <!--              </div>-->

              <div class="form-group clearfix" v-if="getMember.licence_active.length>0">
                <label>Licence du {{ getMember.licence_active[0].date_debut }}
                  au
                  {{ getMember.licence_active[0].date_fin }}</label>
                <p>
                  <button
                    :class="{'disabled':getMember.licence_active.length==0}"
                    @click="printEtiquetteIndividuelle(getMember.licence_active[0].id)"
                    type="button" class="btn btn-primary btn-flat col-xs-4 margin">Imprimer
                    l'étiquette (individuelle)
                  </button>
                  <button type="button"
                          @click="printCarteAnnuelle(getMember.licence_active[0].id,true)"
                          :class="{'disabled':getMember.licence_active.length==0}"
                          class="btn btn-primary btn-flat col-xs-4 margin">
                    Imprimer la carte
                    annuelle de licence
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#tab_1" data-toggle="tab" aria-expanded="true">Logs</a>
              </li>
              <li class="">
                <a href="#tab_2" data-toggle="tab" aria-expanded="false">Dossiers de suivi</a>
              </li>
              <li class="">
                <a href="#tab_3" data-toggle="tab" aria-expanded="false">Fichiers liés</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
                <b-table
                  id="tableLogsMember"
                  responsive bordered striped hover
                  :items="getMember.log"
                  :fields="logsOptions.columnsLog"
                  :current-page="logsOptions.pagination_meta.current_page"
                  :per-page="logsOptions.pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="created_at" slot-scope="row">
                    {{ row.item.date }}
                  </template>
                  <span slot="fullDescription" slot-scope="data" v-html="replaceOldUrl(data.value)">
                  </span>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getMember.log.length"
                              v-model="logsOptions.pagination_meta.current_page"
                              :per-page="logsOptions.pagination_meta.per_page">
                </b-pagination>
              </div>
              <div class="tab-pane" id="tab_2">
                Vide pour l'instant
              </div>
              <div class="tab-pane " id="tab_3">
                <b-table
                  id="tableFilesMember"
                  responsive bordered striped hover
                  :items="getMember.file"
                  :fields="filesOptions.columns"
                  :current-page="filesOptions.pagination_meta.current_page"
                  :per-page="filesOptions.pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="created_at" slot-scope="row">
                    {{ row.item.date }}
                  </template>
                  <template slot="link" slot-scope="row">
                    <a :href="getProcessEnv.STORAGE_URL+row.item.nom" target="_blank">
                      {{ row.item.titre }}
                    </a>
                  </template>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getMember.file.length"
                              v-model="filesOptions.pagination_meta.current_page"
                              :per-page="filesOptions.pagination_meta.per_page">
                </b-pagination>
              </div>
              <!-- /.tab-pane -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box ">
            <div class="overlay"
                 v-if="this.disabledBtn"
            >
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-body">
            </div>
            <div class="box-footer">
              <button type="button"
                      class="btn btn-lg btn-primary btn-flat margin pull-right"
                      :disabled="errors.count()!=0 || !this.numLibre || this.disabledBtn || this.loadingInputs.length>0"
                      @click="sendForm()"
              >
                Modifier la fiche
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
// import VueUploadComponent from 'vue-upload-component'
import UploadFiles from '../../Communs/UploadFiles'

import cpAndVille from '../../Communs/cpAndVille'


var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('lodash')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  data() {
    return {
      villeTemp: null,
      numLicenceExist: null,
      numLibre: true,
      loadingInputs: [],
      disabledBtn: false,
      dataTableLogMember: null,
      dataTableFilesMember: null,
      loadingSecretariatBox: false,
      files: [],
      logsOptions: {
        columnsLog: [
          {
            label: 'Date',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Action',
            key: 'fullDescription',
            sortable: false,
          },
          {
            label: 'Responsable',
            key: 'user',
            sortable: true,
          },
        ],
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 40,
          to: 1,
          total: 1
        },
      },
      filesOptions: {
        columns: [
          {
            label: 'Date',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Link',
            key: 'link',
            sortable: true,
          },
          {
            label: 'Nom',
            key: 'titre',
            sortable: false,
          },
          {
            label: 'Responsable',
            key: 'user',
            sortable: true,
          },
        ],
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 40,
          to: 1,
          total: 1
        },
      },
      urlUploadFile: '',
      addFileUpload: null
    }
  },
  computed: {
    ...mapGetters({
      getProfessions: 'getProfessions',
      getPays: 'getPays',
      getVilles: 'getVilles',
      getStatutsSportifs: 'getStatutsSportifs',
      getRoute: 'getRoute',
      getProcessEnv: 'getProcessEnv',
      getMember: 'getMember'
    }),

  },
  mounted: function () {
    var these = this
    this.urlUploadFile = this.getRoute('Secretariat.addFile');
  },
  created() {
    this.checkIfNumeroLicenceExist = _.debounce(this.checkIfNumeroLicenceExist, 300);
  },
  watch: {},
  components: {
    cpAndVille,
    UploadFiles,
    // FileUpload: VueUploadComponent
  },
  methods: {
    ...mapActions({}),
    replaceOldUrl: function (url) {
      return _.replace(url, 'http://intranet.abft.be/uploads/', this.getProcessEnv.STORAGE_URL) && _.replace(url, 'https://intranet.abft.be/uploads/', this.getProcessEnv.STORAGE_URL)
    },
    showModal: function (id) {
      $(id).modal('show')
    },
    closeModal: function (id) {
      $(id).modal('hide')
    },
    allFilesUploaded: function () {
      this.closeModal("#modalAddFile")
      this.refreshMemberFiles()
    },
    printCarteAnnuelle: function (id_licence = null, qrCode = true) {
      if (!id_licence)
        return;
      this.loadingSecretariatBox = true
      let these = this;
      let route = qrCode ? 'Secretariat.carteAnnuelleMembreQrcode' : 'Secretariat.carteAnnuelleMembre'
      this.$http.post
      (
        this.getRoute(route),
        JSON.stringify({"id_licence": id_licence}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, these.getMember.fullName + "_licence.pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération de la carte")
        this.loadingSecretariatBox = false
      });
    },
    printEtiquetteIndividuelle: function (id_licence = null) {
      if (!id_licence)
        return;
      this.loadingSecretariatBox = true
      let these = this;
      this.$http.post
      (
        this.getRoute('Secretariat.etiquetteIndividuelleMembre'),
        JSON.stringify({"id_licence": id_licence}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, these.getMember.fullName + "_licence.pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération de la carte")
        this.loadingSecretariatBox = false
      });
    },
    printDemandeLicence: function (year = null) {
      if (!year)
        year = moment().year();
      this.loadingSecretariatBox = true
      let these = this;
      this.$http.post
      (
        this.getRoute('Secretariat.demandeLicence'),
        JSON.stringify({"id_membre": this.getMember.id, "year": year}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
        FileSaver.saveAs(blob, these.getMember.fullName + "_demande_licence.docx");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération de la demande de licence")
        this.loadingSecretariatBox = false
      });
    },
    constructForm: function () {
      return JSON.stringify({
        "sexe": this.getMember.sexe,
        "nom": this.getMember.nom,
        "prenom": this.getMember.prenom,
        "date_naissance": this.getMember.date_naissance,
        "adresse": this.getMember.adresse,
        "cp": this.getMember.cp,
        "ville": this.getMember.ville,
        "nationalite": this.getMember.nationalite,
        "mail": this.getMember.mail,
        "telephone": this.getMember.telephone,
        "gsm": this.getMember.gsm,
        "affichage_num": this.getMember.affichage_num,
        "num_kukkiwon": this.getMember.num_kukkiwon,
        "num_gal": this.getMember.num_gal,
        "discipline": this.getMember.discipline,
        "show_in_ranking": this.getMember.show_in_ranking,
        "numlicenceABFT": this.getMember.numlicenceABFT,
        "date_entree": this.getMember.date_entree,
        "id_statut_sportif": this.getMember.id_statut_sportif,
        "comment":this.getMember.comment,
        "date_casier_judiciaire": this.isValidDate(this.getMember.date_casier_judiciaire) ? this.getMember.date_casier_judiciaire  : null,
      })
    },
    sendForm: function () {
      this.disabledBtn = true;
      let self = this;
      this.$http.put(this.getRoute('Secretariat.member.update') + this.getMember.id, this.constructForm()).then(function (response) {
        self.$noty.success("La fiche du membre a bien été modifiée")
        this.disabledBtn = false
      }, (response) => {
        self.$noty.error("Erreur dans la modification de la fiche")
        this.disabledBtn = false
      });
    },
    isValidDate:function(date) {
      const format = "DD/MM/YYYY";
      const parsedDate = moment(date, format, true);
      // Vérifier si la date est valide après l'analyse
      return parsedDate.isValid();
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
//                _.find(this.loadingInputs, function (inputNames) {
//                    return inputNames.id == input;
//                })
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
    getNewNumeroLicence: function () {
      this.addToLoadingInputs('numlicenceABFT')
      this.$http.get(this.getRoute('getNewNumeroLicence')).then((response) => {
        this.getMember.numlicenceABFT = response.body
        this.removeFromLoadingInputs('numlicenceABFT')
      }, (response) => {
      });
    },
    checkIfNumeroLicenceExist: function () {
      this.removeFromLoadingInputs('numlicenceABFT')
      this.addToLoadingInputs('numlicenceABFT')
      var these = this;
      this.$http.post(this.getRoute('checkIfNumeroLicenceExist'), {
        id_membre: these.getMember.id,
        numlicence: these.getMember.numlicenceABFT,
      }, {
        // use before callback
        before(request) {
          // abort previous request, if exists
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          // set previous request on Vue instance
          this.previousRequest = request;
        }
      }).then((response) => {
        // these.$consoleLog(response.body)
        this.numLicenceExist = _.isEmpty(response.body) ? null : response.body
        this.numLibre = this.numLicenceExist == null ? true : false
        this.removeFromLoadingInputs('numlicenceABFT')
      }, (response) => {
        self.$noty.error("Erreur dans la vérification du numéro de licence")
        this.removeFromLoadingInputs('numlicenceABFT')
      });
    },
    show_select_ville: function () {
      return _.isArray(this.getMember.ville) && this.getMember.ville.length > 1
    },
    villeByCp: function (cp) {
      var result = _.filter(this.getVilles, function (item) {
        return item.cp == cp;
      });
      if (result.length == 0)
        return this.getMember.ville = ""
      if (result.length == 1)
        return this.getMember.ville = result[0].name

      this.getMember.ville = result
    },
    setVilleMember: function (value) {
      this.getMember.ville = value;
    },
    setcpMember: function (value) {
      this.getMember.cp = value;
    },
    moment: function () {
      return moment()
    },
    supprimerMembre: function () {
      if (this.getMember.licences.length > 0) {
        this.$noty.error("Vous devez supprimer les licences du membre avant de supprimer le membre lui-même.")
        return
      }

      let these = this
      let self = this
      this.$dialog.confirm('' +
        'Confirmez-vous la suppression de ce membre ?<br/><br/> ' +
        'VOUS DEVEZ SUPPRIMER TOUTES LES LICENCES DU MEMBRE POUR LE SUPPRIMER ENSUITE<br/><br/> ' +
        'Toutes inscriptions aux stages/formations, participation aux compétitions, relation aux comités clubs et données comptables seront supprimées ',
        {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Supprimer le membre',
          cancelText: 'Annuler',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
        })
        .then(function (dialog) {
          setTimeout(() => {
            self.$http.delete(self.getRoute('Secretariat.member.destroy') + self.getMember.id)
              .then(function (response) {
                self.$noty.success("Membre supprimé")
                self.$router.push('/');
                dialog.close();
              }, (response) => {
                self.$noty.error("Erreur dans la suppression.")
                dialog.close();
              });
          }, 1000);
        })
        .catch(function () {
          // console.log('Clicked on cancel')
        });
    },
    refreshMemberFiles: function () {
      this.$http.get(this.getRoute('getFilesMember') + this.getMember.id)
        .then((response) => {
          this.getMember.file = response.body.file
        }, (response) => {
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/MainFormMember.vue